import React, { useState } from 'react';
import './internalComments.css';

export default function InternalComments({ shipment_number, value, onConfirm, onClose }) {
  const [comments, setComments] = useState(value);

  const handleChange = e => {
    setComments(e.target.value);
  };

  return (
    <div className="overlay">
      <div className="internal-comments-content">
        <span className="overlay-close" onClick={onClose}>
          &times;
        </span>
        <p>Commentaires internes du dossier {shipment_number}:</p>
        <div className="internal-comments-textarea-container">
          <textarea
            className="internal-comments-textarea"
            onChange={handleChange}
            value={comments}
          ></textarea>
        </div>
        <button type="button" onClick={() => onConfirm(comments)}>
          Valider
        </button>
      </div>
    </div>
  );
}
